module.exports = __webpack_public_path__ + "static/media/generic-product.22ad1eee.png";